import React from 'react';
import {StyleSheet} from 'react-native';
import {Box, HStack, Text, VStack} from 'native-base';
import SwitchInput from './SwitchInput';
import {ISummary} from '../interfaces/summary.interfaces';

import {formatCurrencyValue} from '../../../../../../../utils/format';
import {CurrencyOptionEnum} from '../../../../../../../constants/enumerations';
import {message as t} from '../../../../../../../utils/messages';
import {PrimaryButton} from '../../../../../../../components/buttons';

type ItemProps = {
  currency: CurrencyOptionEnum | null;
  summary: ISummary;
  defineTransportProvider: boolean;
  requestTransportQuote: boolean;
  onTransporteQuoteToogle?: (toogleValue: boolean) => void;
  onTransportProviderToogle?: (toogleValue: boolean) => void;
  onContinueToogle?: () => void;
};

const OrderSummary = (props: ItemProps) => {
  const {
    currency,
    summary,
    defineTransportProvider,
    requestTransportQuote,
    onTransporteQuoteToogle,
    onTransportProviderToogle,
    onContinueToogle,
  } = props;

  const handleTransporteQuoteToogle = (toogleValue: boolean) => {
    if (onTransporteQuoteToogle) {
      onTransporteQuoteToogle(toogleValue);
    }
  };

  const handleTransportProviderToogle = (toogleValue: boolean) => {
    if (onTransportProviderToogle) {
      onTransportProviderToogle(toogleValue);
    }
  };

  const handleContinueToogle = () => {
    if (onContinueToogle) {
      onContinueToogle();
    }
  };

  return (
    <>
      <VStack style={styles.summaryBox}>
        <HStack justifyContent={'space-between'} style={styles.summaryItem}>
          <Text style={styles.summaryItemLabel} fontWeight={'extrabold'}>
            {t('salesman-order-begin-summary-items')}
          </Text>
          <Text style={styles.summaryItemValue}>{summary.count}</Text>
        </HStack>
        <HStack justifyContent={'space-between'} style={styles.summaryItem}>
          <Text style={styles.summaryItemLabel} fontWeight={'extrabold'}>
            {t('salesman-order-begin-summary-subtotal')}
          </Text>
          <Text style={styles.summaryItemValue}>
            {currency && formatCurrencyValue(summary.subTotal, currency)}
          </Text>
        </HStack>
        <HStack justifyContent={'space-between'} style={styles.summaryItem}>
          <Text style={styles.summaryItemLabel} fontWeight={'extrabold'}>
            {t('salesman-order-begin-summary-iva')}
          </Text>
          <Text style={styles.summaryItemValue}>
            {currency && formatCurrencyValue(summary.iva, currency)}
          </Text>
        </HStack>
        <HStack justifyContent={'space-between'} style={styles.summaryItem}>
          <Text style={styles.summaryItemLabelTotal} fontWeight={'extrabold'}>
            {t('salesman-order-begin-summary-total')}
          </Text>
          <Text style={styles.summaryItemValue}>
            {currency && formatCurrencyValue(summary.total, currency)}
          </Text>
        </HStack>
        {currency === CurrencyOptionEnum.foreign && (
          <HStack justifyContent={'space-between'} style={styles.summaryItem}>
            <Text style={styles.summaryItemLabel} fontWeight={'extrabold'}>
              {t('salesman-order-begin-summary-igtf')}
            </Text>
            <Text style={styles.summaryItemValue}>
              {currency && formatCurrencyValue(summary.igtf, currency)}
            </Text>
          </HStack>
        )}
      </VStack>
      {!defineTransportProvider && (
        <SwitchInput
          label="salesman-order-begin-request-transport"
          value={requestTransportQuote}
          onToggle={handleTransporteQuoteToogle}
        />
      )}

      {!requestTransportQuote && (
        <SwitchInput
          label="salesman-order-begin-add-transport-provider"
          value={defineTransportProvider}
          onToggle={handleTransportProviderToogle}
        />
      )}

      <Box>
        <PrimaryButton
          label="salesman-order-begin-continue-button"
          onPress={handleContinueToogle}
        />
      </Box>
    </>
  );
};
export default OrderSummary;

const styles = StyleSheet.create({
  summaryItem: {
    borderBottomWidth: 1,
    borderColor: '#0000001F',
    marginBottom: 7,
    marginTop: 5,
  },
  summaryItemLabel: {
    color: '#00000099',
  },
  summaryItemLabelTotal: {
    color: '#000000DE',
  },
  summaryItemValue: {
    color: '#000000DE',
  },
  summaryBox: {
    backgroundColor: '#F1F3F4',
    padding: 22,
    borderRadius: 10,
    marginTop: 15,
    marginBottom: 30,
  },
  companyIcon: {
    marginLeft: 10,
  },
});
